



































































































































































import Vue from 'vue'
import UnderlineTextButton from '@/components/Global/UnderlineTextButton.vue'
import QRCameraScanner from '@/components/Global/QRCameraScanner.vue'
import TypeIcons from '@/components/InstallDevices/TypeIcons.vue'
import {
  installDeviceForm,
  rules,
  expansionPanelStates,
  expansionPanelDefaultState,
  TRACEFY_PRESET_LOCAL_STORAGE_KEY
} from '@/components/InstallDevices/constants'
import ImportPresetDialog from '@/components/InstallDevices/ImportPresetDialog.vue'
import ManagePresetsDialog from '@/components/InstallDevices/ManagePresetsDialog.vue'
import ExpansionPanel from '@/components/InstallDevices/ExpansionPanel.vue'
import ImeiStatus from '@/components/InstallDevices/InstallImeiStatus.vue'
import { mutations, portalState } from '@/state'
import {
  apiDropdownsEntityBrands,
  apiDropdownsEntityColors,
  apiDropdownsEntityEngineBrands,
  apiDropdownsEntityMaintenancePlans,
  apiDropdownsEntityModels,
  apiDropdownsEntityEngineModels,
  apiDropdownsEntityPresets,
  apiDropdownsEntityTags,
  apiDropdownsEntityTypes,
  apiGetPresetDetails,
  apiInstallDevice,
  apiReplaceDevice,
  apiSearchDevices,
  apiGetReplaceEntityDetails,
  apiDropdownsEntitiesWithImei
} from '@/api'

type Tag = { id: string; type: string; name: string }

const { DISABLED, ENABLED, INVALIDATED, VALIDATED } = expansionPanelStates

export default Vue.extend({
  name: 'InstallDevice.vue',
  components: { ImeiStatus, ExpansionPanel, ImportPresetDialog, TypeIcons, UnderlineTextButton, QRCameraScanner, ManagePresetsDialog },
  props: {
    replaceDeviceMode: Boolean,
    isMobile: Boolean
  },
  computed: {
    hasCustomers () {
      return portalState.user.businesses.some((b: { has_customers: boolean }) => b.has_customers)
    },
    showLicensePlateInput () {
      const { type } = this.form
      return !['eBike', 'eCargoBike'].some(t => t === type)
    },
    noDataText () {
      const p = [
        { p: !this.searchImeiText, s: 'search', args: [] },
        { p: this.searchImeiText?.length < 6, s: 'needNumbers', args: [(6 - this.searchImeiText?.length || 0), (6 - (this.searchImeiText?.length || 0) > 1 ? 's' : '')] },
        { p: this.devicesLoading, s: 'searching', args: [] },
        { p: true, s: 'notFound', args: [] }
      ]
      return p
        .reduce(({ passed, str }, { p, s, args }) => p && !passed
          ? { passed: true, str: this.t({ s: `form.imei.${s}`, component: 'InstallDevices' }, ...args) }
          : { passed, str }, { passed: false, str: '' }).str
    }
  },
  data () {
    return {
      useCameraToScanQR: false,
      presetModalOpened: false,
      managePresetsModalOpened: false,
      preset: null,
      devicesLoading: true,
      OEMDevice: false,
      searchImeiText: '',
      entities: [],
      devices: [],
      presets: [],
      types: [],
      colors: [],
      brands: [],
      models: [],
      engineBrands: [],
      engineModels: [],
      maintenancePlans: [],
      tags: [],
      timeout: null,
      step: 0,
      totalSteps: 3,
      form: { ...installDeviceForm },
      expansionPanelState: [...expansionPanelDefaultState],
      rules,
      isInstalling: false
    }
  },
  methods: {
    debounce (action: () => any) {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(async () => action(), 500)
    },
    formatCustomerAndCheckValidation () {
      if (!this.form.is_customer) {
        this.form.first_name_customer = null
        this.form.last_name_customer = null
        this.form.email_customer = null
        this.form.phone_customer = null
        this.form.is_customer = false
        return true
      }
      if (this.form.is_customer && !this.validator(3)) {
        this.expansionPanelState[3] = INVALIDATED
        return false
      } else {
        return true
      }
    },
    imeiSearch (imei: string) {
      this.searchImeiText = imei
      if (imei?.length < 6 || !imei) return
      this.debounce(async () => {
        this.devicesLoading = true
        apiSearchDevices(imei).then((res: any) => {
          this.devices = res.data.data
          this.devicesLoading = false

          const clearOEMDevice = () => {
            this.OEMDevice = false
            // this.form.brand = ''
          }
          if (this.devices.length !== 1) {
            clearOEMDevice()
            return
          }
          const OEMBrand_id = this.devices[0].brand_id
          const OEM = this.brands.filter((v: { id: string, name: string}) => v.id === OEMBrand_id)
          if (OEMBrand_id && OEM.length > 0) {
            const OEMName = OEM[0].name
            this.OEMDevice = true
            this.form.brand = OEMName
          } else {
            clearOEMDevice()
          }
        })
      })
    },
    scanResultHandler (e: string) {
      this.imeiSearch(e)
      this.$refs.imeiAutocomplete.$refs.input.focus()
      this.$refs.imeiAutocomplete.isMenuActive = true
    },
    brandHandler (brand: { id: string; name: string }) {
      if (brand?.id) {
        this.form.brand = brand.name
        this.form.brand_id = brand.id
        apiDropdownsEntityModels(brand.id).then(res => { this.models = res.data.data })
      } else {
        this.models = []
      }
    },
    engineBrandHandler (brand: { id: string; name: string }) {
      if (brand?.id) {
        this.form.engine_brand = brand.name
        this.form.engine_brand_id = brand.id
        apiDropdownsEntityEngineModels(brand.id).then(res => { this.engineModels = res.data.data })
      } else {
        this.engineModels = []
      }
    },
    validator (step: number) {
      switch (step) {
        case 0:
          if (!this.replaceDeviceMode) {
            return typeof this.form.is_customer === 'boolean'
          } else {
            return this.$refs.replaceStep0?.validate()
          }
        case 1:
          return this.$refs.installStep1.validate()
        case 2:
          return this.$refs.installStep2.validate()
        case 3:
          return this.$refs.installStep3.validate()
      }
    },
    automaticStepHandler () {
      const { step } = this
      switch (step) {
        case 0:
          if (!this.validator(step)) return
          this.expansionPanelState[step] = VALIDATED
          this.expansionPanelState[1] = ENABLED
          if (this.form.replace_entity_id || !this.replaceDeviceMode) {
            this.step = 1
          } else if (this.replaceDeviceMode) {
            this.expansionPanelState[step] = ENABLED
          }
          break
        case 1:
          if (!this.validator(step)) return
          this.expansionPanelState[step] = VALIDATED
          this.expansionPanelState[2] = ENABLED
          this.step = 2
          break
        case 2:
          if (this.validator(step)) {
            this.expansionPanelState[step] = VALIDATED
            if (this.hasCustomers) {
              this.expansionPanelState[3] = ENABLED
            } else {
              this.expansionPanelState[3] = VALIDATED
            }
          } else {
            this.expansionPanelState[step] = INVALIDATED
          }
          break
        case 3:
          if (this.validator(step)) {
            this.expansionPanelState[step] = VALIDATED
          } else {
            this.expansionPanelState[step] = INVALIDATED
          }
          break
      }
    },
    stepClickHandler (i: number) {
      const { step } = this
      if (this.validator(step)) {
        this.expansionPanelState[step] = VALIDATED
        if (this.expansionPanelState[step + 1] !== DISABLED) {
          this.step = i
        }
      } else {
        this.expansionPanelState[step] = INVALIDATED
      }
      if (this.isMobile) {
        window.scrollTo(0, 0)
      }
    },
    handleInstallClick() {
      this.isInstalling = true;
      this.installDevice();
    },
    handleReplaceClick() {
      this.isInstalling = true;
      this.replaceDevice();
    },
    installDevice () {
      if (!this.formatCustomerAndCheckValidation()) {
        this.isInstalling = false;
        return mutations.setSnackbar('error', this.t({ s: 'form.validation.customerInfoRequired', component: 'InstallDevices' }))
      }
      this.$refs.tagsCombobox.blur()
      this.$nextTick(() => {
        mutations.setSnackbar()
        apiInstallDevice({ ...this.form }).then(() => {
          mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar' }))
          this.resetState()
          this.$emit('resetRecentEntities')
          this.expansionPanelState[1] = ENABLED
        }).catch(e => {
          mutations.setSnackbar('error', e.response.data.message)
        }).finally(() => {
          this.isInstalling = false;
        });
      })
    },
    replaceDevice () {
      this.formatCustomerAndCheckValidation()
      this.$refs.tagsCombobox.blur()
      this.$nextTick(() => {
        mutations.setSnackbar()
        apiReplaceDevice(this.form.replace_entity_id, { ...this.form }).then(() => {
          this.resetState()
          mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar' }))
          this.$emit('resetRecentEntities')

        }).catch(e => {
          mutations.setSnackbar('error', e.response.data.message)
        }).finally(() => {
          this.isInstalling = false;
        });
      })
    },
    resetState () {
      this.form = { ...installDeviceForm }
      this.step = 0
      this.OEMDevice = false
      this.expansionPanelState = [...expansionPanelDefaultState]
      if (!this.hasCustomers && !this.replaceDeviceMode) {
        this.expansionPanelState[1] = ENABLED
        this.step = 1
      }
      if (this.preset && !this.replaceDeviceMode) {
        this.importHandler(this.preset)
      }
    },
    removePreset () {
      this.preset = null
      window.localStorage.removeItem(TRACEFY_PRESET_LOCAL_STORAGE_KEY)
      this.resetState()
    },
    importPreset (id: string) {
      this.preset = id
      this.importHandler(id)
    },
    importDataIntoForm (data: any) {
      const { type, type_id, name, color, short_name, license_plate, brand, brand_id, model, engine_brand, engine_brand_id, engine_model, maintenance_plans, tags, odo } = data
      const { form } = this
      form.name = name
      form.type = type
      form.type_id = type_id
      form.color = color || ''
      form.model = model || ''
      form.short_name = short_name || ''
      form.license_plate = license_plate || ''
      form.odo = odo || 0
      form.engine_model = engine_model || ''
      form.maintenance_plan_id = maintenance_plans?.map((p: {id: string}) => p.id)[0] || null
      form.tags = tags?.map((t: {name: string}) => t.name) || []
      this.brandHandler({ id: brand_id, name: brand })
      this.engineBrandHandler({ id: engine_brand_id, name: engine_brand })
    },
    importHandler (id: string) {
      if (!id) return
      if (!this.replaceDeviceMode) {
        apiGetPresetDetails(id).then(res => {
          this.importDataIntoForm(res.data.data)
        })
      } else {
        apiGetReplaceEntityDetails(id).then(res => {
          this.importDataIntoForm(res.data.data)
        })
      }
    },
    getPresets () {
      this.presets = []
      apiDropdownsEntityPresets().then(res => {
        this.presets = res.data.data
      })
    },
    initialize () {
      this.getPresets()
      apiDropdownsEntitiesWithImei().then(res => { this.entities = res.data.data })
      apiDropdownsEntityTypes().then(res => { this.types = res.data.data })
      apiDropdownsEntityColors().then(res => { this.colors = res.data.data })
      apiDropdownsEntityBrands().then(res => { this.brands = res.data.data })
      apiDropdownsEntityEngineBrands().then(res => { this.engineBrands = res.data.data })
      apiDropdownsEntityTags().then(res => { this.tags = res.data.data })
      apiDropdownsEntityMaintenancePlans().then(res => { this.maintenancePlans = res.data.data })
    }
  },
  async mounted () {
    this.initialize()
    if (!this.hasCustomers) {
      this.expansionPanelState[1] = ENABLED
      this.step = 1
    }
  },
  watch: {
    form: {
      handler () {
        this.automaticStepHandler()
        if (this.step > 1 && this.form.imei === '') {
          this.step = 1
          this.expansionPanelState[1] = INVALIDATED
        }
        if (this.replaceDeviceMode && this.step === 2) {
          setTimeout(() => this.automaticStepHandler(), 500)
        }
      },
      deep: true
    },
    replaceDeviceMode (val) {
      this.resetState()
      if (!val) {
        this.importPreset(this.preset)
      }
    }
  }
})
